<!-- Update the .webpage attribute of a TouchDecoder. -->

<template>
  <v-layout
    column
    align-center
  >
    <v-layout
      class="full-width px-2 pt-3 pb-5"
      justify-center
      align-center
      wrap
      :style="{'max-width': textFieldMaxWidth}"
    >
      <v-text-field
        v-model="newWebpage"
        :label="$t('touchPlayerWebpageHint')"
        :disabled="updatingWebpage"
        :rules="[rules.url]"
        counter="512"
        @keyup.esc="newWebpage = originalWebpage"
        @keyup.enter="onSubmit"
      />
      <v-slide-x-reverse-transition>
        <div
          v-if="touchDecoderWebpageHasBeenChanged"
          class="ml-3"
        >
          <v-layout align-center>
            <btn-abort
              round
              :loading="updatingWebpage"
              class="ml-0"
              @click="onAbort"
            />
            <btn-ok
              round
              :loading="updatingWebpage"
              :disabled="!newWebpageIsValidUrl"
              class="mr-0"
              @click="onSubmit"
            />
          </v-layout>
        </div>
      </v-slide-x-reverse-transition>
    </v-layout>
    <touch-decoder-screenshot :decoder="decoder" />
  </v-layout>
</template>

<script>
import BtnAbort from '@/components/ButtonAbort';
import BtnOk from '@/components/ButtonOk';
import TouchDecoderScreenshot from './TouchDecoderScreenshot.vue';

export default {
  components: {
    BtnAbort,
    BtnOk,
    TouchDecoderScreenshot,
  },
  props: {
    decoder: {
      type: Object,
      required: true,
    },
    textFieldMaxWidth: {
      type: String,
      default: '800px',
    },
  },
  data() {
    return {
      updatingWebpage: false,
      originalWebpage: '',
      newWebpage: '',
      rules: {
        url: (value) =>
          this.isValidUrl(value) || this.$t('touchPlayerWebpageNoValidUrl'),
      },
    };
  },
  computed: {
    touchDecoderWebpageHasBeenChanged() {
      return this.newWebpage !== this.originalWebpage;
    },
    newWebpageIsValidUrl() {
      return this.isValidUrl(this.newWebpage);
    },
  },
  watch: {
    /** Assign new/original webpage fields initially and when Decoder is refetched. */
    decoder: {
      immediate: true,
      handler: function () {
        this.originalWebpage = this.newWebpage = this.decoder.webpage;
      },
    },
  },
  methods: {
    onAbort() {
      this.newWebpage = this.originalWebpage;
    },
    onSubmit() {
      if (!this.newWebpageIsValidUrl) {
        return;
      }
      this.updateTouchDecoderWebpage(this.decoder, this.newWebpage);
    },
    isValidUrl(text) {
      // Spaces are automatically escaped by the URL() constructor
      // below, so test for it separately here. While it may not be
      // same behaviour as in the browser, it probably helps to avoid
      // typos for our use case.
      const hasSpacesInside = text.split(' ').length > 1;
      if (hasSpacesInside) {
        return false;
      }

      // We only support the http(s) protocol.
      if (!text.startsWith('http://') && !text.startsWith('https://')) {
        return false;
      }

      try {
        new URL(text);
        return true;
      } catch (error) {
        return false;
      }
    },
    updateTouchDecoderWebpage(decoder, newWebpage) {
      this.updatingWebpage = true;
      this.$api
        .updateTouchDecoderWebpage(decoder.id, newWebpage)
        .then((response) => {
          this.$bus.$emit('alert-success', {
            message: 'touchPlayerWebpageUpdatedSuccess',
            translate: true,
            timeout: 2000,
          });
          this.$emit('changed');

          // Invalidate sites cache to display new webpage.
          this.$store.commit('RESET_SITES');
        })
        .catch((error) => {
          this.$bus.$emit('alert-error', {
            message: 'genericFailFeedback',
            translate: true,
          });
        })
        .finally(() => {
          this.updatingWebpage = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/DecoderDetail/TouchDecoderWebpage.vue